





























import moment from 'moment';
import Vue from 'vue';
import { Inject, Component } from 'vue-property-decorator';
import { MissionAnnualEntity } from '@/entities/mission-annual.entity';
import { UseService } from '@/services/service';
import MissionAnnualService from '@/services/mission-annual.service';
import { MissionExecutionCountEntity } from '@/entities/mission-execution-count.entity';
import MissionExecutionCountService from '@/services/mission-execution-count.service';
import { MissionEntity } from '@/entities/mission.entity';
import { mapGetters } from 'vuex';
import { StaffEntity } from '@/entities/staff.entity';
import MissionDetailItem from '@/views/Mission/Subpage/MissionDetailItem.vue';
import MissionIcon from '../../../assets/icons/icon_mission.svg';

@Component<MissionDetail>({
  components: { MissionDetailItem },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class MissionDetail extends Vue {
  currentStaff!: StaffEntity;
  missionIcon = MissionIcon;

  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => any;

  missionAnnual: MissionAnnualEntity = null;
  missionExecutionCount: MissionExecutionCountEntity[] = [];

  @UseService(MissionAnnualService)
  missionAnnualService: MissionAnnualService;

  @UseService(MissionExecutionCountService)
  missionExecutionCountService: MissionExecutionCountService;

  get contentHeight() {
    return `calc(100vh - ${210}px)`;
  }

  get startOfMonth() {
    return moment().startOf('month').format('YYYY/MM/DD').split('/');
  }

  get endOfMonth() {
    return moment().endOf('month').format('YYYY/MM/DD').split('/');
  }

  async fetchData() {
    this.missionAnnual = await this.missionAnnualService.getMissionAnnualByMonthAnhyear();
    this.missionExecutionCount = await this.missionExecutionCountService.getManyByMonthAndYear();
  }

  get items() {
    if (!this.missionAnnual) return null;
    const missionResult1 = this.missionExecutionCount.filter(
      (item) => item.missionId === this.missionAnnual.missionFirstId,
    )[0];
    const missionResult2 = this.missionExecutionCount.filter(
      (item) => item.missionId === this.missionAnnual.missionSecondId,
    )[0];
    const missionResult3 = this.missionExecutionCount.filter(
      (item) => item.missionId === this.missionAnnual.missionThirdId,
    )[0];

    return {
      results: [missionResult1, missionResult2, missionResult3],
      contents: [
        this.convertContent(this.missionAnnual.missionFirst),
        this.convertContent(this.missionAnnual.missionSecond),
        this.convertContent(this.missionAnnual.missionThird),
      ],
    };
  }

  get contetField() {
    let contentFiled = 'contentEn';
    switch (this.$i18n.locale) {
      case 'ja':
        contentFiled = 'contentJa';
        break;
      case 'en':
        contentFiled = 'contentEn';
        break;
      case 'vi':
        contentFiled = 'contentVi';
        break;
      default:
        break;
    }
    return contentFiled;
  }

  convertContent(missionAnnual: MissionEntity): string {
    const reg = new RegExp('{.+}', 'gi');
    return missionAnnual[this.contetField].replace(
      reg,
      () => Math.ceil(missionAnnual.count * this.currentStaff.companyStaffs),
    );
  }

  async created() {
    await this.fetchData();
    this.$cheeers.socket.on('mission_result@updated', async () => {
      await this.fetchData();
    });
  }
}
